import { useEffect, useState } from "react";
import { SupplierGetSupplierBankById } from "../../Api/Services";
import { useParams } from "react-router-dom";

function SupplierBank() {
  const [data, setData] = useState([]);
  const [isLoading, setLoading] = useState(true);

  let { id } = useParams();

  const start = async () => {
    try {
      const GetSupplierBankByIdData = await SupplierGetSupplierBankById(id);
      if (
        GetSupplierBankByIdData.status &&
        GetSupplierBankByIdData.status === 200
      ) {
        setData(GetSupplierBankByIdData.data.data.data);
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-start align-items-start flex-column element p-5">
          <div className="d-flex justify-content-center align-items-center w-100 p-2 tableC">
            <table className="table">
              <thead className="sticky-header">
                <tr className="trTable">
                  <th>Supplier</th>
                  <th>نام</th>
                  <th>شبا</th>
                  <th>حساب</th>
                  <th>کارت</th>
                  <th>نام کامل</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, key) => (
                  <tr key={key}>
                    <td>{item.supplierName}</td>
                    <td>{item.name}</td>
                    <td>{item.iban}</td>
                    <td>{item.accountNumber}</td>
                    <td>{item.cardNumber}</td>
                    <td>{item.fullName}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SupplierBank;
